import type { CustomTheme } from '.'

export const customTheme: CustomTheme = {
  colors: {
  },
  semanticTokens: {
  },
}
